(function () {
  'use strict';
  var CFG = window.HDBFavPopup || {};
  var STR = CFG.strings || {};
  var WEBHOOK = 'https://homedecobali.app.n8n.cloud/webhook/hdb-favpopup-intake';
  var SEEN_KEY = 'hdb_favpopup_seen_v1';
  var DONE_KEY = 'hdb_favpopup_done_v1';
  var COOLDOWN_DAYS = 30;
  var shown = false, built = false, overlay = null, lastY = 0, idleTimer = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function wishCount() { try { if (window.HDBWishlist && typeof HDBWishlist.count === 'function') return HDBWishlist.count(); return (JSON.parse(localStorage.getItem('hdb_wishlist_v1')) || []).length; } catch (e) { return 0; } }
  function isDone() { try { return localStorage.getItem(DONE_KEY) === '1'; } catch (e) { return false; } }
  function markDone() { try { localStorage.setItem(DONE_KEY, '1'); } catch (e) {} }
  function recentlySeen() { try { var t = parseInt(localStorage.getItem(SEEN_KEY), 10); return t ? (Date.now() - t) < COOLDOWN_DAYS * 864e5 : false; } catch (e) { return false; } }
  function markSeen() { try { localStorage.setItem(SEEN_KEY, String(Date.now())); } catch (e) {} }
  function locale() { try { return (window.HDBWishlist && HDBWishlist.iso) || document.documentElement.lang || ''; } catch (e) { return ''; } }

  function build() {
    if (built) return; built = true;
    overlay = document.createElement('div');
    overlay.className = 'hdb-favpop__overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', STR.headline || '');
    var priv = CFG.privacyUrl ? ' <a href="' + CFG.privacyUrl + '" target="_blank" rel="noopener">' + esc(STR.privacy || '') + '</a>' : '';
    overlay.innerHTML =
      '<div class="hdb-favpop">' +
        '<button type="button" class="hdb-favpop__close" aria-label="' + esc(STR.close || 'Close') + '">\u00d7</button>' +
        '<div class="hdb-favpop__heart" aria-hidden="true"><svg viewBox="0 0 24 24" width="40" height="40"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg></div>' +
        '<h2 class="hdb-favpop__title">' + esc(STR.headline || '') + '</h2>' +
        (STR.sub ? '<p class="hdb-favpop__sub">' + esc(STR.sub) + '</p>' : '') +
        '<form class="hdb-favpop__form" novalidate>' +
          '<input type="email" class="hdb-favpop__email" name="email" required autocomplete="email" placeholder="' + esc(STR.placeholder || 'Email') + '">' +
          '<button type="submit" class="hdb-favpop__submit">' + esc(STR.button || 'Save') + '</button>' +
        '</form>' +
        '<p class="hdb-favpop__consent">' + esc(STR.consent || '') + priv + '</p>' +
        '<div class="hdb-favpop__success" hidden><p>' + esc(STR.success || '') + '</p></div>' +
      '</div>';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) hide(); });
    overlay.querySelector('.hdb-favpop__close').addEventListener('click', hide);
    overlay.querySelector('.hdb-favpop__form').addEventListener('submit', submit);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) hide(); });
  }

  function open() {
    if (shown || isDone() || recentlySeen()) return;
    if (wishCount() < 1) return;
    build(); shown = true; markSeen();
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    var em = overlay.querySelector('.hdb-favpop__email'); if (em) setTimeout(function () { try { em.focus(); } catch (e) {} }, 120);
  }
  function hide() { if (overlay) overlay.classList.remove('is-open'); teardown(); }

  function submit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var input = form.querySelector('.hdb-favpop__email');
    var email = (input && input.value || '').trim();
    if (!email || email.indexOf('@') < 1) { if (input) input.focus(); return; }
    var btn = form.querySelector('.hdb-favpop__submit'); if (btn) { btn.disabled = true; }
    var body = new URLSearchParams();
    body.append('email', email);
    body.append('locale', locale());
    fetch(WEBHOOK, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() })
      .then(function () { succeed(); })['catch'](function () { succeed(); });
  }
  function succeed() {
    markDone();
    if (!overlay) return;
    var f = overlay.querySelector('.hdb-favpop__form'); if (f) f.style.display = 'none';
    var c = overlay.querySelector('.hdb-favpop__consent'); if (c) c.style.display = 'none';
    var s = overlay.querySelector('.hdb-favpop__success'); if (s) s.hidden = false;
    setTimeout(hide, 2600);
  }

  function onMouseOut(e) { if (e.clientY <= 0 && !e.relatedTarget) open(); }
  function armIdle() { clearTimeout(idleTimer); idleTimer = setTimeout(open, (CFG.idleSeconds || 30) * 1000); }
  function onScroll() { var y = window.pageYOffset || document.documentElement.scrollTop; if (y < 10 && lastY - y > 40) open(); lastY = y; armIdle(); }
  function teardown() { document.removeEventListener('mouseout', onMouseOut); window.removeEventListener('scroll', onScroll); clearTimeout(idleTimer); }

  function initTriggers() {
    if (isDone() || recentlySeen()) return;
    var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (touch) { lastY = window.pageYOffset || 0; window.addEventListener('scroll', onScroll, { passive: true }); armIdle(); }
    else { document.addEventListener('mouseout', onMouseOut); }
  }

  function boot() {
    if (/[?&]favpopup=1(&|$)/.test(location.search)) { try { localStorage.removeItem(DONE_KEY); localStorage.removeItem(SEEN_KEY); } catch (e) {} build(); open(); return; }
    initTriggers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.HDBFavPopup = window.HDBFavPopup || {};
  window.HDBFavPopup.open = function () { shown = false; try { localStorage.removeItem(DONE_KEY); localStorage.removeItem(SEEN_KEY); } catch (e) {} build(); open(); };
})();
